/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import PageableCollection from '@/backbone/PageableCollection';
import StringCell from '@/backgrid/StringCell';
import { DateCell } from '@/backgrid/MomentCell';
import GridView from '@/views/GridView';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';

const CommandOrdersGridView = GridView.extend({
  initialize() {
    this.options.columns = [
      {
        name: 'id',
        label: 'Order ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'formName',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'internalOrderStatus',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'submittedOn',
        label: 'Date Submitted',
        cell: DateCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'approvedOn',
        label: 'Approved Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'expectedDeliveryDate',
        label: 'Expected Delivery Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: '',
        label: '',
        sortable: false,
        editable: false,
        cell: ButtonLinkCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          newTab: true,
          href(model) {
            return `#order/${model.get('id')}`;
          }
        })
      }
    ];
    const orders = this.model.get('customerOrders');
    this.options.collection = new PageableCollection(orders, { pageSize: 10 });
    this.options.emptyText = 'No Command Orders';
  }
});

export default CommandOrdersGridView;
